import { Billing } from 'components/Protected';

const BillingPage = () => {
  return <Billing />
}

export default BillingPage;
